"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var defaultScrollIntoViewOptions = {
    block: 'nearest',
};
var useScrollToSingleSelect = function (listRefs, selectedIndex, scrollIntoViewOptions) {
    if (scrollIntoViewOptions === void 0) { scrollIntoViewOptions = defaultScrollIntoViewOptions; }
    react_1.useEffect(function () {
        if (typeof selectedIndex === 'number') {
            var itemRefNow = listRefs.current[selectedIndex];
            if (itemRefNow && itemRefNow.current) {
                itemRefNow.current.scrollIntoView(scrollIntoViewOptions);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedIndex, listRefs.current.length]);
    return {};
};
exports.default = useScrollToSingleSelect;
